/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { cockpit_AbsenceRatePeriodDTO } from './cockpit_AbsenceRatePeriodDTO';
import type { cockpit_AbsenceRateRowDTO } from './cockpit_AbsenceRateRowDTO';
import type { cockpit_AbsenceRateScopeDTO } from './cockpit_AbsenceRateScopeDTO';
import type { cockpit_AbsenceRateSummaryDTO } from './cockpit_AbsenceRateSummaryDTO';
export type cockpit_AbsenceRatesResponseDTO = {
    as_of?: string;
    basis?: string;
    compare_to?: cockpit_AbsenceRatesResponseDTO.compare_to;
    group_by?: cockpit_AbsenceRatesResponseDTO.group_by;
    include_child_sick?: boolean;
    metric?: string;
    periods?: Array<cockpit_AbsenceRatePeriodDTO>;
    rows?: Array<cockpit_AbsenceRateRowDTO>;
    scope?: cockpit_AbsenceRateScopeDTO;
    summary?: cockpit_AbsenceRateSummaryDTO;
};
export namespace cockpit_AbsenceRatesResponseDTO {
    export enum compare_to {
        PREVIOUS_YEAR = 'previous_year',
        NONE = 'none',
    }
    export enum group_by {
        NONE = 'none',
        CHILDCARE = 'childcare',
        GROUP = 'group',
        EMPLOYEE = 'employee',
    }
}

